<div class="container">
  <div *ngIf="unpaidInvoice$ | async">
    <app-unpaid-invoice-banner [unpaidInvoice]="unpaidInvoice$ | async"></app-unpaid-invoice-banner>
  </div>

  <div *ngIf="showAdd; else showShop">
    <div [ngClass]="{
      'container-content-xlarge': isXLarge(),
      'container-content-large': isLarge(),
      'container-content-medium': isMedium(),
      'container-content-small': isSmall(),
      'container-content-xsmall': isXSmall()
    }">
      <div class="container-content-add">
        <button mat-raised-button (click)="create()" color="primary">
          <mat-icon>post_add</mat-icon>
          New
        </button>
        <button mat-raised-button (click)="create()" color="primary">
          <mat-icon>amp_stories</mat-icon>
          Newsletter Templates
        </button>
      </div>
      <div class="container-content-grid">
      </div>
    </div>
  </div>
</div>
<ng-template #showShop>
  <app-buy-subscription-plan-banner></app-buy-subscription-plan-banner>
</ng-template>